import React from "react";
import { InspectionTemplate } from "../../Templates/InspectionTemplate";

export const Inspection = () => {
  return <InspectionTemplate />;
};
